import { Component, OnInit } from '@angular/core';
import { UsersService } from '../../services/users/users.service';
import { MatTableDataSource } from '@angular/material/table';
import { IListUsers, IRegisterUser } from '@app/shared/interfaces/users.interface';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { SelectionModel } from '@angular/cdk/collections';
import { ContentDialogGenericComponent } from '@app/shared/components/content-dialog-generic/content-dialog-generic.component';
import { FormUserComponent } from '../../components/form-user/form-user.component';
import { BehaviorSubject, filter, take } from 'rxjs';
import { ThemePalette } from '@angular/material/core/common-behaviors/color';
import { PageEvent } from '@angular/material/paginator';
import { Router } from '@angular/router';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.sass'],
})
export class UsersComponent implements OnInit {
  currentPage = 1;
  pageSize = 10;
  dataSource: MatTableDataSource<IListUsers>;
  displayedColumns: Array<string> = ['name', 'email', 'permission', 'edit'];
  selection = new SelectionModel<IListUsers>(true, []);
  color: ThemePalette = 'primary';
  searchField: string;
  private dialogRefSubject = new BehaviorSubject<any>(null);
  lengthSource = 0;
  permissionRouter: string;

  constructor(
    private usersService: UsersService,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private router: Router
  ) {}

  ngOnInit(): any {
    this.getUsersFilter();
    this.permissionRouter = this.router.url.replace('usuarios', 'permissoes');
  }

  public getUsersService(): UsersService {
    return this.usersService;
  }

  getUsersFilter() {
    const pages = {
      page: this.currentPage,
      pageSize: this.pageSize,
    };

    this.usersService.getUsers(this.searchField, pages).subscribe({
      next: (response: IListUsers[]) => {
        this.dataSource = new MatTableDataSource(response);
        this.lengthSource = response.length;
      },
      error: (err) => {
        this.toastr.error(err.errors);
      },
    });
  }

  getChangeUserStatusMessage(row) {
    const changeUserStatusMessage = row.isActive ? 'Desativar' : 'Ativar';
    return `${changeUserStatusMessage} usuário`;
  }

  changeUserStatus(row: IListUsers) {
    this.selection.toggle(row);

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    let userStatusMessage = row.isActive ? 'desativar' : 'ativar';

    dialogConfig.data = {
      message: `
      Tem certeza que deseja ${userStatusMessage} o usuário ${row.user} ?`,
    };

    const dialogRef = this.dialog.open(ContentDialogGenericComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        this.usersService
          .changeUserStatus({
            userId: row.id,
            newStatus: !row.isActive,
          })
          .subscribe({
            next: () => {
              userStatusMessage = row.isActive ? 'desativado' : 'ativado';
              this.toastr.success(`Usuário ${userStatusMessage} com sucesso.`);
              this.ngOnInit();
            },
            error: (err) => {
              this.toastr.error(err.errors);
            },
          });
      }
    });
  }

  onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;

    this.getUsersFilter();
  }

  private openFormUserDialog(data: any): void {
    const dialogRef = this.dialog.open(FormUserComponent, {
      minWidth: '50%',
      maxWidth: '90%',
      height: 'auto',
      panelClass: 'no-padding-dialog',
      data: { ...data },
    });

    this.dialogRefSubject.next(dialogRef);
  }

  async editUser(data: IRegisterUser): Promise<void> {
    const modifiedData = { ...data, action: 'edit' };
    this.openFormUserDialog(modifiedData);

    const dialogRef = await this.dialogRefSubject.pipe(take(1)).toPromise();
    const { up } = await dialogRef.afterClosed().toPromise();

    if (up) {
      this.initializeComponent();
    }
  }

  add() {
    const data = { action: 'create' };
    this.openFormUserDialog(data);

    this.dialogRefSubject
      .pipe(
        take(1),
        filter((result) => result && result.up === true)
      )
      .subscribe(() => {
        this.initializeComponent();
      });
  }

  private initializeComponent(): void {
    this.ngOnInit();
  }
}
